<template>
  <v-layout
    row
    wrap
    class="pa-4"
  >
    <v-flex xs12>
      <Toggle
        v-model="IdCard.visitor_id"
        title="Visitor ID Card"
        caption="If enabled new visitors should scan their ID Card"
      />
      <Toggle
        v-model="IdCard.returning_visitor_id"
        title="Returning Visitor ID Card"
        caption="If enabled returning visitors should scan their ID Card again, which enhances security"
      />
    </v-flex>
  </v-layout>
</template>
<script>
import Toggle from '@/components/common/Toggle';

export default {
  name: 'IdCardScan',
  components: {
    Toggle
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        visitor_id: false,
        returning_visitor_id: false
      })
    }
  },
  data() {
    return {
      IdCard: {}
    };
  },
  watch: {
    data: {
      handler(val) {
        if (!val) return;
        this.IdCard = Object.assign({}, val);
      },
      immediate: true
    }
  },
  deactivated() {
    const validation = true;
    this.$emit('update', [this.IdCard, validation]);
  }
};
</script>

